import {Tache} from '@/models';

export default [
	{
		path: '/taches',
		name: 'taches',
		meta: {
			title: 'Liste des taches',
			granted: [ 'API_GET_CLIENT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Tache.vue')
	},
	{
		path: '/taches/show/:id',
		name: 'tache-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Tache/Show.vue'),
				class: Tache
			}),
			editRoute: { name: 'tache-edit' },
		},
		meta: {
			title: 'Détail d\'un tache',
			granted: [ 'API_GET_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/taches/edit/:id',
		name: 'tache-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Tache/Edit.vue'),
				class: Tache
			}),
		},
		meta: {
			title: 'Edition d\'un tache',
			granted: [ 'API_PUT_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];